import React, { useEffect, useState } from 'react';
import styles from './Input.module.css';

type Guess = {
  letter: string,
  status: 'unchecked' | 'correct' | 'outOfPlace' | 'incorrect'
};

interface InputProps {
  inputValue: string;
  playerName?: string;
  disabled?: boolean;
  guesses?: Guess[];
  gameOver: boolean;
}

interface SingleInputProps {
  char: string,
  status: string,
  disabled: boolean,
  index: number,
}

const SingleInput: React.FC<SingleInputProps> = ({ char, status, disabled, index}) => {
  const [flip, setFlip] = useState(false);
  const [flipped, setFlipped] = useState(false);
  let className = '';

  if (status === 'correct') {
    className += ` ${styles.correct}`;
  } else if (status === 'outOfPlace') {
    className += ` ${styles.outOfPlace}`;
  } else if (status === 'incorrect') {
    className += ` ${styles.incorrect}`;
  }

  if (disabled) {
    className += ` ${styles.disabled}`;
  }

  useEffect(() => {
    if (status !== 'unchecked') {
      setFlip(true);
      setTimeout(() => {
        setFlipped(true);
        setTimeout(() => {
          setFlip(false);
          setFlipped(false);
        }, 800);
      }, 800);
    }
  }, [status]);

  const flipClass = flip ? styles.flip : '';
  const flippedClass = flipped ? styles.flipped : '';

  return (
    <div className={`${styles.inputFlip} ${flipClass} ${flippedClass}`}>
      <div
        contentEditable={false}
        className={`${className} ${styles.inputFront}`}
      >
        {char !== ' ' ? char : ''}
      </div>
      <div
        contentEditable={false}
        className={`${className} ${styles.inputBack}`}
      >
        {char !== ' ' ? char : ''}
      </div>
    </div>
  )
};

const Input: React.FC<InputProps> = ({ inputValue, playerName = '', disabled, guesses, gameOver}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-around',
        flexWrap: 'wrap', 
        alignItems: 'center',
        marginBottom: '3px',
      }}
    >
      {
        Array.from(playerName).map((char, index) => {
          const inputIndex = Array.from(playerName.slice(0, index)).filter((char) => char !== ' ' && char !== '-').length;
          return (char === ' ' || char === '-') ? (
            <div key={index} style={{ width: '50px' }} />
          ) : (
            <SingleInput
              key={index}
              char={inputValue[inputIndex] ?? ''}
              status={guesses && guesses[inputIndex] ? guesses[inputIndex].status : 'unchecked'}
              disabled={!!(disabled && inputIndex === Array.from(playerName.replace(/ /g, '')).length - 1) || gameOver}
              index={inputIndex}
            />
          );
        })
      }
    </div>
  );
};

export default Input;
